import axiosClient, { ResponseSuccessTotal } from "../axiosClient"

export interface IUnitByUserPermission {
  unitId: number
  unitTitle: string
  groupPermissionTitle: string
}

export const getListUnitByUserPermission = async (search?: string) => {
  const url = "groupPermission/listUnitsByUserPermission"
  const params = { search }
  const result: ResponseSuccessTotal<IUnitByUserPermission[]> = await axiosClient.get(url, { params })
  return result
}
